
//opens Spectrum Customizer via popup
function createCustomizer() {
  const host = window.location.host;
  let customizerURL;

  if (host.includes('dev') || host.includes('staging') || host.includes('127')) {
    customizerURL = "http://cdn-staging.spectrumcustomizer.com/miir/frontend/js/customizer.min.js";
  } else {
    customizerURL = "https://cdn.spectrumcustomizer.com/miir/frontend/js/customizer.min.js";
  }

  let oldScript = document.querySelector(`script[src^="${customizerURL}"]`);
  if (oldScript) oldScript.remove();

  if(!oldScript) {
    const script = document.createElement("script");
    script.src = customizerURL;
    script.async = true;
    document.body.appendChild(script);
  }

  if (!document.getElementById('spectrum-customizer')) {
    const div = document.createElement('div');
    div.tabIndex = -1;
    div.id = 'spectrum-customizer';
    document.body.appendChild(div);
    div.focus();
  }

}

  function createCustomizerPopup() {
    var preloadedQuantityContainer = document.getElementsByClassName("bulk-order");

    let productParams = new URLSearchParams(document.location.search);
    var productVariant = productParams.get("variant");
    var matchedSKU = findMatchingSKU(allProductData, productVariant);

    var grabCustomProduct = matchedSKU;
    window.spectrumLoadProduct = grabCustomProduct;
    window.spectrumLoadQuantity = preloadedQuantityContainer[0].value; 

    createCustomizer();
    lastFocused = document.activeElement;
  }

  window.addEventListener('DOMContentLoaded', () => {

    const urlParams = new URLSearchParams(window.location.search);
    const hasRecipeID = urlParams.has('recipeId');

    if (hasRecipeID) {
      createCustomizerPopup();
    }

  });
